import React, { PureComponent } from 'react';
import cx from 'clsx';

import Toast from './Toast';
import * as moduleStyls from './ContactForm.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';

function encode(data) {
    return Object.keys(data)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
}

class ContactForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            name: '',
            email: '',
            phone: '',
            contactMessage: '',
            'bot-field': '',
            showToast: false,
            toastMsg: '',
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({
                'form-name': form.getAttribute('name'),
                ...this.state,
            }),
        })
            .then(() => {
                window.scrollTo(0, 0);
                this.setState({
                    company: '',
                    name: '',
                    email: '',
                    phone: '',
                    contactMessage: '',
                    'bot-field': '',
                    toastMsg: '已收到您的訊息！將盡速與您聯繫',
                    showToast: true,
                });
            })
            .catch(() => {
                this.setState({
                    toastMsg: '抱歉，系統出了狀況。麻煩您透過 Email 或是電話與我們聯繫',
                    showToast: true,
                });
            });
    }

    hideToast = () => {
        this.setState({ showToast: false });
    }

    render() {
        const {
            company,
            name,
            email,
            phone,
            contactMessage,
            toastMsg,
            showToast,
        } = this.state;
        return (
            <>
                <section className={cx(themeStyles.pt8, themeStyles.ptMd11, themeStyles.pb8, themeStyles.pbMd14)}>
                    <div className={themeStyles.container}>
                        <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                            <div className={cx(themeStyles.col12, themeStyles.colMd10, themeStyles.colLg8, themeStyles.textCenter)}>
                                <h2 className={themeStyles.fontWeightBold}>
                                    直接與我們聯繫
                                </h2>
                                <p className={cx(themeStyles.fontSizeLg, themeStyles.textMuted, themeStyles.mb7, themeStyles.mbMd9)}>
                                    歡迎留下您的聯絡資訊，我們會盡速與您聯繫
                                </p>
                            </div>
                        </div>
                        <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                            <div className={cx(themeStyles.col12, themeStyles.colMd12, themeStyles.colLg10)}>
                                <form
                                    name="contact"
                                    method="POST"
                                    data-netlify="true"
                                    netlify-honeypot="bot-field"
                                    onSubmit={this.handleSubmit}
                                >
                                    <p className={moduleStyls.ohohhoney}>
                                        <label>
                                            Don’t fill this out if you are human:
                                            <input name="bot-field" value={this.state['bot-field']} onChange={this.handleChange} />
                                        </label>
                                    </p>
                                    <input type="hidden" name="form-name" value="contact" />
                                    <div className={themeStyles.row}>
                                        <div className={cx(themeStyles.col12, themeStyles.colMd6)}>
                                            <div className={cx(themeStyles.formGroup, themeStyles.mb5)}>
                                                <label htmlFor="company">公司名稱</label>
                                                <input
                                                    type="text"
                                                    className={themeStyles.formControl}
                                                    name="company"
                                                    aria-describedby="companyHelp"
                                                    placeholder="輸入公司名稱"
                                                    onChange={this.handleChange}
                                                    value={company}
                                                />
                                            </div>
                                        </div>
                                        <div className={cx(themeStyles.col12, themeStyles.colMd6)}>
                                            <div className={cx(themeStyles.formGroup, themeStyles.mb5)}>
                                                <label htmlFor="name">聯絡人名稱</label>
                                                <input
                                                    type="text"
                                                    className={themeStyles.formControl}
                                                    name="name"
                                                    aria-describedby="nameHelp"
                                                    placeholder="輸入聯絡人名稱"
                                                    required
                                                    onChange={this.handleChange}
                                                    value={name}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={themeStyles.row}>
                                        <div className={cx(themeStyles.col12, themeStyles.colMd6)}>
                                            <div className={cx(themeStyles.formGroup, themeStyles.mb5)}>
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    className={themeStyles.formControl}
                                                    name="email"
                                                    aria-describedby="emailHelp"
                                                    placeholder="輸入 Email"
                                                    required
                                                    onChange={this.handleChange}
                                                    value={email}
                                                />
                                                <small
                                                    id="emailHelp"
                                                    className={cx(themeStyles.formText, themeStyles.textMuted)}
                                                >
                                                    我們會透過 Email 與您聯繫
                                                </small>
                                            </div>
                                        </div>
                                        <div className={cx(themeStyles.col12, themeStyles.colMd6)}>
                                            <div className={cx(themeStyles.formGroup, themeStyles.mb5)}>
                                                <label htmlFor="phone">聯絡電話</label>
                                                <input
                                                    type="tel"
                                                    minLength="9"
                                                    className={themeStyles.formControl}
                                                    name="phone"
                                                    aria-describedby="nameHelp"
                                                    placeholder="輸入聯絡電話"
                                                    onChange={this.handleChange}
                                                    value={phone}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={themeStyles.row}>
                                        <div className={themeStyles.col12}>
                                            <div className={cx(themeStyles.formGroup, themeStyles.mb7, themeStyles.mbMd9)}>
                                                <label htmlFor="contactMessage">
                                                    有什麼是我們可以為您服務的？
                                                </label>
                                                <textarea
                                                    className={themeStyles.formControl}
                                                    name="contactMessage"
                                                    rows="5"
                                                    placeholder="告訴我們有什麼可以為您服務的！"
                                                    required
                                                    onChange={this.handleChange}
                                                    value={contactMessage}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div data-netlify-recaptcha="true" />
                                    <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                                        <div className={themeStyles.colAuto}>
                                            <button type="submit" className={cx(themeStyles.btn, themeStyles.btnPrimary, themeStyles.lift)}>
                                                傳送訊息
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                {showToast
                    ? <Toast msg={toastMsg} onClose={this.hideToast} />
                    : null}
            </>
        );
    }
}

export default ContactForm;
